export async function verifGrous(rows) {
  return verifDefault(rows);
}

function findWord(word, str) {
  return RegExp("\\b" + word + "\\b").test(str);
}



// template default tout les pharmacie
// function verifDefault(rows) {
//   var array = [];
//   var verif = false

//   if (rows[0] && rows[0].some(item => item && item.toString() === 'Article')) {
//     verif = true
//   }
//   console.log(verif,rows[0])
//   if (verif) {
//     rows.map((row, index) => {
//       let code = "";
//       let code_pct = "";
//       if (row.length > 0) {
//         if (row[1] !== undefined)
//           code =
//             typeof row[1] == "string"
//               ? row[1].toString().replaceAll(" ", "")
//               : row[1].toString();

//         code_pct =
//           typeof row[0] == "string"
//             ? row[0].toString().replaceAll(" ", "")
//             : row[0] ? row[0].toString() : "";
//         if (row && row !== "undefined" && code.trim() !== "Code") {
//           array.push({
//             Designation: row[2] ? row[2].toString() : "",
//             quantite: row[4] !== undefined && row[4] ? Math.round(row[4]) : 0,
//             Code: code,
//             Code_pct: code_pct,
//             idProduit: null,
//           });
//         }
//       }

//       return true;
//     });
//   }
//   else {

//     if (rows[0].length > 2)
//       return [];
//     else {
//       rows.map((row, index) => {
//         let code = "";
//         let code_pct = "";
//         if (row.length > 0) {
//           if (row[0] !== undefined)
//             code =
//               typeof row[0] == "string"
//                 ? row[0].toString().replaceAll(" ", "")
//                 : row[0].toString();

//           code_pct =
//             typeof row[0] == "string"
//               ? row[0].toString().replaceAll(" ", "")
//               : row[0] ? row[0].toString() : "";
//           if (row && row !== "undefined" && code.toLowerCase().trim() !== "code") {
//             array.push({
//               Designation: "",
//               quantite: row[1] !== undefined && row[1] ? Math.round(row[1]) : 0,
//               Code: code,
//               Code_pct: code_pct,
//               idProduit: null,
//             });
//           }
//         }

//         return true;
//       });
//     } 

//   }

//     return array;
//   }

function verifDefault(rows) {
  let array = [];
  if (!rows || rows.length === 0) return array;

  const header = rows[0].map(h => h?.toString().trim());

  // --- Trouver les index ---
  const indexCodePct = header.findIndex(h => h.toLowerCase() === "code pct");
  const indexCode = header.findIndex(h => h.toLowerCase() === "code article");
  const indexArticle = header.findIndex(h => h.toLowerCase() === "article");
  const indexQuantite = header.findIndex(h => h.toLowerCase() === "quantite");
  const indexColisage = header.findIndex(h => h.toLowerCase() === "colisage");

  // Vérifier si l'entête correspond au bon format
  const hasDefaultHeader = indexArticle !== -1;

  // Saute la première ligne (header)
  rows.slice(1).map((row) => {
    if (!row || row.length === 0) return true;

    let code_pct = indexCodePct !== -1 ? (row[indexCodePct] || "").toString().trim() : "";
    let code = indexCode !== -1 ? (row[indexCode] || "").toString().trim() : "";

    let designation =
      indexArticle !== -1 ? (row[indexArticle] || "").toString().trim() : "";

    let quantite =
      indexQuantite !== -1 && row[indexQuantite]
        ? Math.round(row[indexQuantite])
        : 0;
    console.log(code_pct, quantite)
    // Exclure les lignes du header
    // if (code_pct.toLowerCase() === "code pct" || quantite.toLowerCase() === "quantite")
    //   return true;

    array.push({
      Designation: designation,
      quantite: quantite,
      Code: code ? code.replaceAll(" ", "") : code_pct.replaceAll(" ", ""),
      Code_pct: code_pct.replaceAll(" ", ""),
      idProduit: null,
      indexRow: rows.indexOf(row) // <<< ajoute index réel !
    });

    return true;
  });

  return array;
}
